<!--
For other possible props for a-input:
@see https://2x.antdv.com/components/input

If we need a different default values compared
to the default values of the library apply it here
-->

<template>
  <AnimatedInputLabelLayout
    :label="label"
    :value="$attrs.value"
    :isFocused="isFocused || isFocusedInternal"
    :hasPlaceholder="hasPlaceholder"
  >
    <a-input
      :autocomplete="$attrs.autocomplete ?? 'disabled'"
      v-bind="$attrs"
      :on-focus="focusHandler"
      :on-blur="blurHandler"
      :maxlength="maxlength"
      ref="inputRef"
      :placeholder="placeholder"
      autocorrect="disabled"
      autocapitalize="disabled"
      spellcheck="false"
      @keypress="allowLatinSymbolsNumbers($event)"
      @drop="allowLatinSymbolsNumbers($event)"
      @paste="allowLatinSymbolsNumbers($event)"
    >
      <template #prefix>
        <slot name="prefix" />
      </template>

      <template #suffix>
        <slot name="suffix" />
      </template>

      <template #addonAfter>
        <slot name="addonAfter" />
      </template>
    </a-input>
  </AnimatedInputLabelLayout>
</template>

<style lang="scss"></style>

<script lang="ts">
import { defineComponent, ref } from "vue";
import AnimatedInputLabelLayout from "@/shared/components/forms/AnimatedInputLabelLayout.vue";
import { useVModel } from "vue-composable";
import { noop } from "lodash";
import { allowLatinSymbolsNumbers } from "@/shared/utils/inputs";

export default defineComponent({
  inheritAttrs: false,
  props: {
    label: { type: String },
    isFocusedModel: { type: Boolean, default: false },
    autofocus: { type: Boolean, default: false },
    /**
     * If true - will allow other input like Cyrillic, Arabic, etc
     */
    allowNonLatin: {
      type: Boolean,
      default: false,
    },
    maxlength: {
      type: Number,
      default: 100,
    },
    placeholder: String,
  },
  emits: ["on-custom-blur-handler", "on-custom-focus"],
  setup(props, { emit }) {
    const isFocused = useVModel(props, "isFocusedModel");
    // We need this internally in case no props is passed for [isFocusedModel]
    // [useVModel] does not automatically create a reactive variable if there is no props
    const isFocusedInternal = ref();

    const focusHandler = () => {
      isFocused.value = true;
      isFocusedInternal.value = true;
      emit("on-custom-focus");
    };

    const inputRef = ref();
    if (props.autofocus) {
      setTimeout(() => inputRef.value?.focus(), 500);
    }

    const blurHandler = () => {
      isFocused.value = false;
      isFocusedInternal.value = false;
      emit("on-custom-blur-handler");
    };

    return {
      focusHandler,
      blurHandler,
      inputRef,
      isFocused,
      isFocusedInternal,
      hasPlaceholder: props.placeholder != null,
      allowLatinSymbolsNumbers: props.allowNonLatin
        ? noop
        : allowLatinSymbolsNumbers,
    };
  },
  components: {
    AnimatedInputLabelLayout,
  },
});
</script>
